module.exports = __webpack_public_path__ + "static/media/UPS.1e886a80.svg";